import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useChildMatches } from '@tanstack/react-router';
import { useMemo } from 'react';
import useHeader from '@hooks/useHeader';

const settingsHeaders = {
    account: 'Account Settings',
    emails: 'Email Settings',
    billing: 'Billing Settings',
};

const Settings = () => {
    const { t } = useTranslation();

    const match = useChildMatches();

    const headerProps = useMemo(() => {
        return {
            title: t('Settings'),
            titleTypographyProps: { color: 'primary.main' },
        };
    }, []);

    useHeader(headerProps);

    return (
        <Box display="flex" flex={1}>
            <Card
                sx={{
                    flex: 1,
                    backgroundColor: 'secondaryContainer.main',
                }}
            >
                <CardHeader
                    title={t(
                        settingsHeaders[
                            match?.[0]?.pathname.split('/').at(-1) || 'account'
                        ],
                    )}
                    titleTypographyProps={{ color: 'primary.main' }}
                />
                <CardContent>
                    <Outlet />
                </CardContent>
            </Card>
        </Box>
    );
};

export default Settings;
